import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { IParameters, ParameterEntityType } from '../interface/parameters';

export const SYSTEM_PARAMETERS_QUERY_KEY = 'system-parameters';

interface IUseFetchSystemParametersOptions {
  parametersToGet: ParameterEntityType;
  enabled?: boolean;
}

export const useFetchSystemParameters = ({
  parametersToGet,
  enabled = true,
}: IUseFetchSystemParametersOptions) => {
  const url = `${API_URLS_ENTITY.SYSTEM}${API_URLS_ENTITY.PARAMETERS}`;
  return useQuery<IParameters, Error>({
    queryKey: [SYSTEM_PARAMETERS_QUERY_KEY, parametersToGet],
    queryFn: () => get(url, { parametersToGet }),
    staleTime: 60 * 1000,
    enabled,
  });
};
